// @flow

import type { NotificationState, NotificationName } from './state'

export const mutations = {
  toggle (state: NotificationState, name: NotificationName): void {
    state.notification[name] = !state.notification[name]
  }
}
